<template>
    <div class="user-config">
        <el-form ref="form" :model="formModel" label-width="100px">
            <!-- 仅对拥有消息通知权限的用户展示 -->
            <div v-if="$hasPermission('action.messageCenter')" class="notification-section">
                <el-divider content-position="left">消息中心通知偏好</el-divider>

                <el-row :gutter="20">
                    <el-col :span="24">
                        <el-form-item label="消息订阅">
                            <div>
                                <el-checkbox v-model="formModel.notification.subscriptions.order_exception">
                                    订单异常提醒
                                </el-checkbox>
                            
                                <el-checkbox v-model="formModel.notification.subscriptions.order_completed">
                                    订单完成提醒
                                </el-checkbox>

                                <el-checkbox v-model="formModel.notification.subscriptions.shop_offline">
                                    店铺掉线提醒
                                </el-checkbox>
                            </div>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="20">
                    <el-col :span="24">
                        <el-form-item label="提醒渠道">
                            <div>
                                <el-checkbox v-model="formModel.notification.channels.browserDesktop" @change="handleDesktopChannelChange">
                                    浏览器桌面通知
                                </el-checkbox>
                         
                                <el-checkbox v-model="formModel.notification.channels.inApp">
                                    应用内卡片提醒
                                </el-checkbox>

                                <el-checkbox v-model="formModel.notification.channels.serverChan">
                                    Server酱推送（微信 / 移动端）
                                </el-checkbox>
                            </div>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="20" v-if="formModel.notification.channels.serverChan">
                    <el-col :span="24">
                        <el-form-item label="Server酱密钥">
                            <div style="display: flex; align-items: center; max-width: 600px;">
                                <el-input
                                    v-model="formModel.notification.serverChan.sendKey"
                                    placeholder="请输入 Server酱 SendKey (如 sctp... 或 SCT...) 或完整推送 URL"
                                    clearable
                                    style="flex: 1;"
                                />
                                <el-button
                                    type="success"
                                    size="small"
                                    style="margin-left: 10px; flex-shrink: 0;"
                                    :loading="testingServerChan"
                                    @click="handleTestServerChan"
                                >
                                    测试推送
                                </el-button>
                            </div>
                            <div class="serverchan-tip">
                                <i class="el-icon-info"></i>
                                支持 <a href="https://doc.sc3.ft07.com/serverchan3/" target="_blank" rel="noopener noreferrer">Server酱³</a>（以 <code>sctp</code> 开头）及 Turbo 版（以 <code>SCT</code> 开头）。可在 
                                <a href="https://sc3.ft07.com/sendkey" target="_blank" rel="noopener noreferrer">Server酱³ SendKey 页面</a> 获取。
                            </div>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-divider></el-divider>
            </div>

            <el-row :gutter="20">
                <el-col :span="24">
                    <el-form-item label="停止词" class="stop-keywords-item">
                        <div style="max-height: 300px;overflow: auto">
                            <div style="display: flex;margin-bottom: 8px"
                                 v-for="(_,index) in formModel.stopKeywords"
                                 :key="index">

                                <el-input
                                    v-model="formModel.stopKeywords[index]"
                                    clearable
                                >
                                </el-input>


                                <div class="flex"
                                     style="margin-left:8px;justify-content: space-between;width: 100px;flex-shrink: 0;">
                                    <el-button type="primary" icon="el-icon-plus"
                                               @click="formModel.stopKeywords.push('')"></el-button>
                                    <el-button type="danger" icon="el-icon-delete"
                                               @click="formModel.stopKeywords.splice(index,1)"
                                               v-if="index != 0"></el-button>

                                </div>
                            </div>
                        </div>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-divider></el-divider>

            <el-row :gutter="20" class="save-row">
                <el-col :span="24">
                    <el-form-item>
                        <el-button type="primary" @click="handleSave">保存</el-button>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>
<script>
import { requestNotificationPermission } from "@/utils/browserNotification";

export default {
    name: "UserConfig",
    props: {
        visible: false,
    },
    data() {
        return {
            testingServerChan: false,
            formModel: this.createDefaultModel()
        }
    },
    watch: {
        visible() {
            if (!this.visible) {
                return
            }
            this.fetchConfig()
        }
    },
    methods: {
        createDefaultModel() {
            return {
                stopKeywords: [],
                notification: {
                    subscriptions: {
                        order_exception: false,
                        order_completed: false,
                        shop_offline: false
                    },
                    channels: {
                        browserDesktop: false,
                        inApp: true,
                        serverChan: false
                    },
                    serverChan: {
                        sendKey: ''
                    }
                }
            }
        },
        normalizeConfig(rawConfig) {
            const defaults = this.createDefaultModel();
            const config = rawConfig || {};
            return {
                ...config,
                stopKeywords: Array.isArray(config.stopKeywords) ? config.stopKeywords : [],
                notification: {
                    subscriptions: {
                        ...defaults.notification.subscriptions,
                        ...(config.notification?.subscriptions || {})
                    },
                    channels: {
                        ...defaults.notification.channels,
                        ...(config.notification?.channels || {})
                    },
                    serverChan: {
                        ...defaults.notification.serverChan,
                        ...(config.notification?.serverChan || {})
                    }
                }
            };
        },
        fetchConfig() {
            this.$http.get(`/users/current`).then(res => {
                this.formModel = this.normalizeConfig(res.data.config)
            })
        },
        async handleDesktopChannelChange(val) {
            if (val) {
                const permission = await requestNotificationPermission();
                if (permission === 'denied') {
                    this.$message.warning('浏览器已阻止桌面通知权限，请在浏览器地址栏左侧网站设置中允许通知');
                    this.formModel.notification.channels.browserDesktop = false;
                } else if (permission === 'unsupported') {
                    this.$message.warning('当前浏览器不支持系统桌面通知');
                    this.formModel.notification.channels.browserDesktop = false;
                } else if (permission === 'granted') {
                    this.$message.success('已获得系统桌面通知权限');
                } else {
                    this.formModel.notification.channels.browserDesktop = false;
                }
            }
        },
        async handleTestServerChan() {
            const sendKey = this.formModel.notification.serverChan?.sendKey?.trim();
            if (!sendKey) {
                this.$message.warning('请先输入 Server酱 SendKey 后再进行测试');
                return;
            }

            this.testingServerChan = true;
            try {
                const res = await this.$http.post('/messageCenter/serverChan/test', {
                    sendKey
                });
                if (res.data?.success) {
                    this.$message.success(res.data.message || 'Server酱测试推送已发送，请在微信或 App 中查收！');
                } else {
                    this.$message.error(res.data?.message || '测试推送失败');
                }
            } catch (err) {
                const msg = err.response?.data?.message || err.message || '测试推送异常，请检查网络或 SendKey';
                this.$message.error(msg);
            } finally {
                this.testingServerChan = false;
            }
        },
        handleSave() {
            this.$refs.form.validate((valid) => {
                if (!valid) {
                    return false;
                }
                this.$http.post(`/users/current/config`, this.formModel).then(() => {
                    this.$message.success('保存成功')
                    if (this.$store && this.$store.state && this.$store.state.user) {
                        this.$set(this.$store.state.user, 'config', JSON.parse(JSON.stringify(this.formModel)));
                    }
                })
            })
        }
    },
    created() {
        this.fetchConfig()
    }
}
</script>

<style scoped lang="scss">
.user-config {
    // 压缩 Element UI 默认的表单和分隔线间距，避免配置弹窗上下留白过大。
    ::v-deep .el-divider {
        margin: 14px 0;
    }

    .notification-section {
        ::v-deep .el-divider:first-child {
            margin-top: 0;
            margin-bottom: 14px;
        }

        ::v-deep .el-form-item {
            margin-bottom: 12px;
        }
    }

    .stop-keywords-item {
        margin-bottom: 8px;
    }

    .save-row {
        ::v-deep .el-form-item {
            margin-bottom: 0;
        }
    }
}

.serverchan-tip {
    margin-top: 6px;
    font-size: 12px;
    color: #909399;
    line-height: 1.5;

    a {
        color: #409EFF;
        text-decoration: none;

        &:hover {
            text-decoration: underline;
        }
    }

    code {
        padding: 1px 4px;
        background-color: #f4f4f5;
        color: #e6a23c;
        border-radius: 3px;
        font-family: monospace;
    }
}
</style>
